var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.order && _vm.displayTipSection(_vm.order)
    ? _c("section", [
        !_vm.includeCssClass ? _c("div", [_c("hr")]) : _vm._e(),
        _vm._v(" "),
        _c("div", { class: { "card panel-white": _vm.includeCssClass } }, [
          _c(
            "div",
            { class: { "card-body": _vm.includeCssClass } },
            [
              _vm.$route.matched[0].path !== "/chat-booking"
                ? _c(
                    "router-link",
                    {
                      staticClass: "btn btn-block btn-secondary",
                      attrs: {
                        to: "/reservation/" + _vm.order.id + "/professional-tip"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("message.professional_tip.title")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.matched[0].path === "/chat-booking"
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-block btn-secondary",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.openFormTipModal()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("message.professional_tip.title")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  ref: "modal",
                  on: { ok: _vm.submitData },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "modal-footer",
                        fn: function(ref) {
                          var ok = ref.ok
                          var cancel = ref.cancel
                          return [
                            _c("div", { staticClass: "w-100" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-start align-items-center"
                                },
                                [
                                  _c("div", { staticClass: "flex-grow-1" }, [
                                    _c("label", { staticClass: "mb-0" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "message.professional_tip.amount"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.totalTip
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "-status-new text-pro-number"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("currency")(_vm.totalTip)
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pr-2" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: { variant: "secondary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.closeModal()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("message.button.cancel")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _vm.paymentMethod !== "promptpay"
                                        ? _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                variant: "info",
                                                disabled: _vm.isLoading
                                              },
                                              on: {
                                                click: function($event) {
                                                  return ok()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.isLoading
                                                      ? _vm.$t(
                                                          "message.button.loading"
                                                        )
                                                      : _vm.$t(
                                                          "message.button.confirm"
                                                        )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              )
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4278048888
                  ),
                  model: {
                    value: _vm.showModal,
                    callback: function($$v) {
                      _vm.showModal = $$v
                    },
                    expression: "showModal"
                  }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "modal-title" }, slot: "modal-title" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("message.professional_tip.title")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("section", [
                    _c("div", [
                      _c("label", { staticClass: "mb-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.professional_tip.select_amount")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.errorMessages.tip_amount
                        ? _c("span", { staticClass: "text-danger" }, [
                            _c("i", {
                              staticClass: "fas fa-exclamation-circle"
                            })
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row no-gutters py-2" },
                      _vm._l(_vm.tips, function(tip, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "col-4 p-2" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn badge badge-pill badge-light text-pro-number text-center w-100",
                                class: [
                                  { "active-button": _vm.selectTip === tip },
                                  "pillTip"
                                ],
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.assignTip("select", tip)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                ฿" +
                                    _vm._s(_vm._f("prettyNumber")(tip)) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", { staticClass: "py-2 text-secondary" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("message.professional_tip.custom_amount")
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.inputTip,
                            expression: "inputTip",
                            modifiers: { number: true }
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "number",
                          inputmode: "numeric",
                          pattern: "[0-9]*",
                          min: "20",
                          max: _vm.maxAmount,
                          placeholder: _vm.$t(
                            "message.professional_tip.custom_amount_hint"
                          )
                        },
                        domProps: { value: _vm.inputTip },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.inputTip = _vm._n($event.target.value)
                            },
                            function($event) {
                              return _vm.assignTip("input", _vm.inputTip)
                            }
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "pt-2 text-remark" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "message.professional_tip.custom_amount_remark"
                              )
                            ) +
                            " " +
                            _vm._s(_vm._f("prettyNumber")(_vm.maxAmount)) +
                            "\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "py-3" }, [
                      _c("div", [
                        _c("span", [
                          _c("i", {
                            staticClass: "fas fa-circle bullet-notification"
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("message.professional_tip.remark01")
                              ) +
                              "\n            "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", [
                          _c("i", {
                            staticClass: "fas fa-circle bullet-notification"
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("message.professional_tip.remark02")
                              ) +
                              "\n            "
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "pt-3" },
                    [
                      _c("div", [
                        _c("label", { staticClass: "mb-0" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.booking.checkout_step.payment_method"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _vm.errorMessages.payment_method
                          ? _c("span", { staticClass: "text-danger" }, [
                              _c("i", {
                                staticClass: "fas fa-exclamation-circle"
                              })
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      [
                        _c("div", { staticClass: "card shadow-sm" }, [
                          _c(
                            "div",
                            { staticClass: "card-body p-3" },
                            [
                              _c("div", { staticClass: "exp" }, [
                                _c("div", { staticClass: "checkbox" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.paymentMethod,
                                        expression: "paymentMethod"
                                      }
                                    ],
                                    attrs: {
                                      type: "radio",
                                      id: "paymentCreditDebit",
                                      name: "paymentMethod",
                                      value: "credit_card",
                                      disabled: !_vm.totalTip
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.paymentMethod,
                                        "credit_card"
                                      )
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          _vm.paymentMethod = "credit_card"
                                        },
                                        _vm.calculateTip
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "mb-0",
                                      attrs: { for: "paymentCreditDebit" }
                                    },
                                    [
                                      _c("span"),
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.booking.payment_step.pay_by_credit_debit_card"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-danger text-remark pt-1 pl-4 ml-2"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.professional_tip.credit_card_remark"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.payment
                                ? [
                                    _vm.paymentMethod === "credit_card"
                                      ? _c(
                                          "div",
                                          { staticClass: "payment-method" },
                                          [
                                            _c("payment-small", {
                                              staticClass: "mt-3",
                                              attrs: { payment: _vm.payment }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.payment === null
                                      ? [_c("loader")]
                                      : _vm._e()
                                  ]
                                : [
                                    _vm.paymentMethod === "credit_card"
                                      ? _c(
                                          "div",
                                          { staticClass: "mt-3" },
                                          [
                                            _c("payment-form", {
                                              ref: "paymentForm",
                                              attrs: {
                                                paymentData: _vm.paymentData
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card shadow-sm" }, [
                          _c("div", { staticClass: "card-body p-3" }, [
                            _vm.globalState.configData.promptpay.status === 1
                              ? _c("div", { staticClass: "exp" }, [
                                  _c("div", { staticClass: "checkbox" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.paymentMethod,
                                          expression: "paymentMethod"
                                        }
                                      ],
                                      ref: "promptpay",
                                      attrs: {
                                        type: "radio",
                                        id: "promptpay",
                                        name: "paymentMethod",
                                        value: "promptpay",
                                        disabled: !_vm.totalTip
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.paymentMethod,
                                          "promptpay"
                                        )
                                      },
                                      on: {
                                        change: [
                                          function($event) {
                                            _vm.paymentMethod = "promptpay"
                                          },
                                          _vm.calculateTip
                                        ]
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "mb-0",
                                        attrs: { for: "promptpay" }
                                      },
                                      [
                                        _c("span"),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.booking.payment_step.pay_by_promptpay"
                                              )
                                            ) +
                                            "\n                      "
                                        ),
                                        _c("img", {
                                          staticClass: "rounded ml-2",
                                          attrs: {
                                            src:
                                              "/static/img/thai_qr_payment.png",
                                            width: "90"
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                ])
                              : _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-start"
                                    },
                                    [
                                      _c("div", [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-circle fa-lg -status-offline"
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "pl-3" }, [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.booking.payment_step.pay_by_promptpay"
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c("img", {
                                          staticClass: "rounded ml-2",
                                          attrs: {
                                            src:
                                              "/static/img/thai_qr_payment.png",
                                            width: "90"
                                          }
                                        })
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pt-3 text-small" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$i18n.locale === "th"
                                              ? _vm.globalState.configData
                                                  .promptpay.remark_th
                                              : _vm.globalState.configData
                                                  .promptpay.remark_en
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.paymentMethod === "promptpay"
                          ? _c(
                              "div",
                              [
                                _c("qr-code-payment", {
                                  ref: "qrCodePayment",
                                  on: { checkQrPayment: _vm.checkQrPayment }
                                }),
                                _vm._v(" "),
                                _c("hr"),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-remark" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.promptpay.payment_remark"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7df44ae", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7df44ae","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/ProfessionalTipSection.vue
// module id = 1751
// module chunks = 0